import React, { Component } from 'react';
import * as Styles from './Styles';
import SvgRefresh from '../../../others/svg_dist/Refresh';
import Button from '../../../components/button/Button';
import SvgArrowLeft from '../../../others/svg_dist/ArrowLeft';
import * as FormManager from '../../../reducers/ui/form';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../../core/Store';
import HoverPopover, { POSITION } from '@react_components/hover_popover';

type State = {};

class ControlsComponent extends Component<PropsFromRedux, State> {
	state = {};

	render() {
		return (
			<Styles.Wrapper id="form-stage2-code">
				<Styles.CodeContainer>
					<Styles.HeadingTopFont>
						kod weryfikacyjny
					</Styles.HeadingTopFont>
					<Styles.HeadingBottomFont>
						wprowadź kod weryfikacyjny, jaki wysłaliśmy do ciebie
						e-mailem
					</Styles.HeadingBottomFont>
					<Styles.InputWrapper>
						<input
							type="text"
							spellCheck={false}
							placeholder="wpisz kod"
							value={this.props.vereficationCode}
							onChange={(e) =>
								this.props.setVereficationCode(e.target.value)
							}
						/>
						<HoverPopover
							content={
								<span>wyślij ponownie kod weryfikacyjny</span>
							}
							position={POSITION.RIGHT}
						>
							<Styles.InputButton
								onClick={() => FormManager.resendOwuMail()}
							>
								<SvgRefresh />
							</Styles.InputButton>
						</HoverPopover>
					</Styles.InputWrapper>
					{(this.props.vereficationCodeError || this.props.error) && (
						<Styles.ErrorFont>
							{this.props.vereficationCodeError ||
								this.props.error}
						</Styles.ErrorFont>
					)}
				</Styles.CodeContainer>
				<Styles.ButtonsContainer>
					<Button
						Icon={<></>}
						label="wstecz"
						onClick={() => FormManager.Dialogs.pushCancelForm()}
						style={{
							margin: '0 10px',
							border: '2px solid #fff',
							color: '#005694',
							fontSize: '13px',
						}}
					/>
					<Button
						Icon={
							!this.props.loaded ? (
								<Styles.StyledSpinnerSvg />
							) : (
								<SvgArrowLeft style={{ fill: '#005694' }} />
							)
						}
						label="przystępuję z obowiązkiem zapłaty"
						onClick={() => FormManager.submitStep2()}
						style={{
							margin: '0 10px',
							backgroundColor: '#F8F96F',
							border: '2px solid #F8F96F',
							fontSize: '14px',
							color: '#005694',
							fontWeight: 600,
							height: '55px',
							width: '300px',
							textAlign: 'center',
							opacity: this.props.canSave ? '1' : '0.5',
							cursor: this.props.canSave
								? 'pointer'
								: 'not-allowed',
						}}
					/>
				</Styles.ButtonsContainer>
			</Styles.Wrapper>
		);
	}
}

interface Own {}

const connector = connect(
	(state: AppState, own: Own) => ({
		vereficationCode: FormManager.Selectors.getVereficationCode(state),
		canSave: FormManager.Selectors.getCanSave(state),
		vereficationCodeError:
			FormManager.Selectors.getVereficationCodeDisplayError(state),
		loaded: FormManager.Selectors.getIsLoaded(state),
		error: FormManager.Selectors.getVereficationCodeError(state),
	}),
	(dispatch) => ({
		setVereficationCode: (code: string) =>
			dispatch(FormManager.Actions.setVereficationCode(code)),
	})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const Controls = connector(ControlsComponent);
export default Controls;
